module.exports = __webpack_public_path__ + "media/assets/images/icon-play-58be034388744d40cd98fa8b204582f4.svg";